import { render, staticRenderFns } from "./productlist.vue?vue&type=template&id=7881283f&scoped=true&"
import script from "./productlist.vue?vue&type=script&lang=js&"
export * from "./productlist.vue?vue&type=script&lang=js&"
import style0 from "./productlist.vue?vue&type=style&index=0&lang=less&"
import style1 from "./productlist.vue?vue&type=style&index=1&id=7881283f&lang=less&scoped=true&"
import style2 from "./productlist.vue?vue&type=style&index=2&id=7881283f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7881283f",
  null
  
)

export default component.exports